import { WSAlert } from "@wingspanhq/fe-component-library";
import React from "react";
import { useModalRequirementsStatusesInfo } from "./useModalRequirementsStatusesInfo";

export const AlertEligibilityRequirementPending: React.FC<{}> = () => {
  const modalRequirementsStatusesInfo = useModalRequirementsStatusesInfo();

  return (
    <WSAlert
      theme="info"
      icon="time"
      title="Eligibility requirements pending"
      mb="L"
      action={{
        text: "Learn more about requirement statuses",
        onClick() {
          modalRequirementsStatusesInfo.open();
        }
      }}
    >
      Once all requirements for this engagement have been completed, you will be
      eligible to receive payments for this engagement.
    </WSAlert>
  );
};
